/// <reference path='references.ts' />
(function($) {

	$.fn.dropdownlist = function(options) {
		// build main options before element iteration
		options = $.extend(true, {}, $.fn.dropdownlist.defaults, options);

		// loop through calculating width for all drop downs first, otherwise we can get inconsistent widths when rendering a set of dropdowns in the same form.
		this.each(function() {
			var $this = $(this);

			$this.data('width', DropdownUtil.calculateWidth($this, '.dropdownlist'));
		});

		function init($this) {
			// build element specific options
			$this.options = $.metadata ? $.extend(true, {}, options, $this.metadata()) : options;
			$this.options = $.fn.dataset ? $.extend(true, $this.options, $this.dataset()) : $this.options;

			var width = $this.data('width');

			var properties = {
				theme: 'trackit',
				width: width,
				height: 15,
				itemHeight: 18,
				dropDownHeight: 360,
				autoDropDownHeight: $this.find('option:not(.default-option)').size() < 20,
				filterable: $this.find('option:not(.default-option)').size() > 20,
				filterPlaceHolder: translate('Find...'),
				searchMode: 'containsignorecase',
				disabled: $this.prop('disabled'),
				scrollBarSize: 10
			};
			var selectionRendererRegexStr = $this.options.selectionRendererRegex;
			if (selectionRendererRegexStr)
			{
				var selectionRendererRegex = new RegExp(selectionRendererRegexStr);
			}
			var isCheckboxes = false;
			if($this.attr('multiple')) {
				properties.checkboxes = true;
				isCheckboxes = true;
			}

			var $defaultOption = $this.find('option.default-option');
			if($defaultOption.size()>0) {
				properties.placeHolder = $.trim($defaultOption.text());
				if (isCheckboxes) {
					$defaultOption.remove();
				}
			}

			var $defaultGroup = null;
			// All options must be in a group
			if ($this.find('optgroup').size()>0) {
				$this.children('option').each(function(){
					var $option = $(this);
					$option.remove();
					if($defaultGroup === null) {
						$defaultGroup = $('<optgroup label="'+$this.closest('.form-row').find('label').text().replace('*','')+'"></optgroup>');
						$this.prepend($defaultGroup);
					}
					$defaultGroup.append($option);
				});
			}

			var selectAllText = null;
			if(isCheckboxes && !$this.data('hide-select-all')) {
				// Create a Select All item
			 	selectAllText = translate('(Select All)');
				if ($this.find('optgroup').size()>0) {
					if($defaultGroup === null) {
						$defaultGroup = $('<optgroup label="'+$this.closest('.form-row').find('label').text().replace('*','')+'"></optgroup>');
						$this.prepend($defaultGroup);
					}
					$defaultGroup.append($('<option value="">'+selectAllText+'</option>'));
				}
			}

			$this.jqxDropDownList(properties);
			var $dropdownlist = $this.next();

			var hiddenName = escape($this.attr('name'));
			var $hidden = $this.closest('form').find('input[name='+hiddenName+']').filter('input:hidden');
			if ($hidden.length == 0) {
				// Give generated hidden input the correct field name
				$hidden = $dropdownlist.find('input:hidden');
				$hidden.attr('name', $this.attr('name'));
			}
			else {
				// hidden input already exists, most likely there are multiple dropdownlists binding to same field (e.g. activity event types)
				if ($hidden.is(':not(.common-hidden)')) {
					// remove the name from the :hidden for previous dropdownlist. Dropdownlists will each have anonymous :hidden.
					$hidden.removeAttr('name');
					// and bind change listener to previous dropdownlist for syncing values to .common-hidden
					$hidden.closest('.jqx-widget.dropdownlist').on('select checkChange', onChange);
					// create a common :hidden and sync other anonymous :hidden to it
					$hidden = $('<input type="hidden" name="' + hiddenName + '" value="' + $hidden.val() + '" class="common-hidden"></input>');
					$dropdownlist.append($hidden);
				}

				// add values for this :hidden to .common-hidden
				var val = $hidden.val();
				val = val + (!val || val.length > 0 ? ',' : '') + $dropdownlist.find('input:hidden').val();
				$hidden.val(val);

				// bind change listener to dropdownlist for syncing values to .common-hidden
				$dropdownlist.on('select checkChange', onChange);
			}

			function onChange() {
				var $dropdownlist = $(this);
				// find .common-hidden
				var $hidden = $dropdownlist.closest('form').find('input:hidden[name='+hiddenName+']');
				var val = $hidden.val();
				var items = $dropdownlist.jqxDropDownList('getItems');
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if(!item.isGroup && item.value) {
						if(item.checked) {
							// item has been checked to append to .common-hidden
							if (!val || !val.match(new RegExp("(?:^|,)"+item.value+"(?:,|$)"))) {
								val = val + (!val || val.length > 0 ? ',' : '') + item.value;
							}
						}
						else {
							if (val && val.match(new RegExp("(?:^|,)"+item.value+"(?:,|$)"))) {
								// item has been unchecked so remove from .common-hidden
								val = val.replace(new RegExp("(^|,)"+item.value+"(,|$)"), '$1').replace(/,$/, '');
							}
						}
					}
				}
				$hidden.val(val);
			}

			// disable the original input so that it doesn't clash with hidden field
			$this.prop('disabled', true);

			// Copy any classes from the option to the item.html
			var items = $dropdownlist.jqxDropDownList('getItems');
			for (var i = 0; i < items.length; i++) {
				var item = items[i];
				if(!item.isGroup) {
					var $option = $this.find('option[value="'+item.value+'"]');
					if($option.attr('class')) {
						item.html = '<span class="'+$option.attr('class')+'">'+item.label+'</span>';
					}
				}
			}

			if(!isCheckboxes)
			{
				if (selectionRendererRegex)
				{
					$dropdownlist.jqxDropDownList('selectionRenderer', function (htmlString)
						{
							if (htmlString) {
								var selectionText = htmlString.text();
								var regexMatch = selectionRendererRegex.exec(selectionText);

								if (regexMatch && regexMatch.length > 0)
								{
									selectionText = regexMatch[0];
								}

								htmlString.text(selectionText);
								return htmlString;
							}
						}
					);
					// selectItem so that Regex based selectionRenderer is called
					$dropdownlist.jqxDropDownList('selectItem',$dropdownlist.jqxDropDownList('getSelectedItem'));
				}
			}
			else if(selectAllText)
			{
				if ($this.find('optgroup').size()==0) {
					$dropdownlist.jqxDropDownList('insertAt', {label: selectAllText, value: null}, 0);
				}

				// Custom renderer to ensure Select All is not displayed in selected values
				$dropdownlist.jqxDropDownList('selectionRenderer', function (htmlString)
					{
						if (htmlString) {
							var result = '';

							var checkedItems = $dropdownlist.jqxDropDownList('getCheckedItems');
							if (checkedItems && checkedItems.length > 0) {
								var i, item;
								if (checkedItems.length > 1 && $this.options['show-checked-count']) {
									var items = $dropdownlist.jqxDropDownList('getItems');
									var checkedCount = 0;
									var totalCount = 0;
									for (i = 0; i < items.length; i++) {
										item = items[i];
										if(!item.isGroup && item.value) {
											totalCount++;
											if(item.checked) { checkedCount++; }
										}
									}
									var $label = $dropdownlist.closest('.form-row').find('label');
									var label = '';
									if($label.length > 0) {
										label = $label.text().replace('*','');
									}
									if(checkedCount == totalCount) {
										result = label.length > 0  ? translate('All {0}', [label]) : translate('All selected');
									}
									else {
										result = label.length > 0  ? translate('{0}/{1} {2}', [checkedCount, totalCount, label]) : translate('{0}/{1} selected', [checkedCount, totalCount]);
									}

								} else {
									for (i = 0; i < checkedItems.length; i++) {
										item = checkedItems[i];
										if (!item.isGroup && item.label != selectAllText) {
											if (result.length > 0) {
												result += ', ';
											}
											result += item.label;
										}
									}
								}
							}
							else {
								result = properties.placeHolder;
							}
							htmlString.text(result);
							htmlString.css("max-width", $dropdownlist.width() - 30);
							htmlString.css("overflow", "hidden");
							htmlString.css("display", "block");
							htmlString.css("width", $dropdownlist.width() - 30);
							htmlString.css("text-overflow", "ellipsis");
							htmlString.css("padding-bottom", 1);
							return htmlString;
						}
					}
				);

				// handle select all item.
				var handleCheckChange = true;
				updateSelectAll();
				$dropdownlist.on('checkChange', function (event) {
					updateSelectAll(event);
				});

			}

			function updateSelectAll(event) {
				if (!handleCheckChange)
					return;

				var items = $.grep($dropdownlist.jqxDropDownList('getItems'), function( item ) {
					return !item.isGroup;
				});
				var firstItem = items[0];
				items.splice(items.indexOf(firstItem), 1);
				var checkedItems = $.grep($dropdownlist.jqxDropDownList('getCheckedItems'), function( item ) {
					return !item.isGroup;
				});
				if (checkedItems.indexOf(firstItem) > -1) {
					checkedItems.splice(checkedItems.indexOf(firstItem), 1);
				}

				if (!event || event.args.label != selectAllText) {
					//noinspection JSUnusedAssignment
					handleCheckChange = false;

					if (checkedItems.length == 0) {
						if (firstItem.visible) {
							$dropdownlist.jqxDropDownList('uncheckIndex', 0);
						} else {
							firstItem.checked = false;
						}
					}
					else if (checkedItems.length < items.length) {
						if (firstItem.visible) {
							$dropdownlist.jqxDropDownList('indeterminateIndex', 0);
						} else {
							firstItem.checked = null;
						}
					}
					else {
						if (firstItem.visible) {
							$dropdownlist.jqxDropDownList('checkIndex', 0);
						} else {
							firstItem.checked = true;
						}
					}
					handleCheckChange = true;
				}
				else {
					//noinspection JSUnusedAssignment
					handleCheckChange = false;
					var notDisabledItems = $.grep($dropdownlist.jqxDropDownList('getItems'), function( item ) {
						return !item.isGroup && !item.disabled;
					});
					if (checkedItems.length < items.length) {
						for (i = 0; i < notDisabledItems.length; i++) {
							item = notDisabledItems[i];
							$dropdownlist.jqxDropDownList('checkIndex', item.index);
						}

						checkedItems = $.grep($dropdownlist.jqxDropDownList('getCheckedItems'), function( item ) {
							return !item.isGroup;
						});
						if (checkedItems.indexOf(firstItem) > -1) {
							checkedItems.splice(checkedItems.indexOf(firstItem), 1);
						}
						if(checkedItems.length < items.length) {
							$dropdownlist.jqxDropDownList('indeterminateIndex', 0);
						}

					}
					else {
						for (i = 0; i < notDisabledItems.length; i++) {
							item = notDisabledItems[i];
							$dropdownlist.jqxDropDownList('uncheckIndex', item.index);
						}

						checkedItems = $.grep($dropdownlist.jqxDropDownList('getCheckedItems'), function( item ) {
							return !item.isGroup;
						});
						if (checkedItems.indexOf(firstItem) > -1) {
							checkedItems.splice(checkedItems.indexOf(firstItem), 1);
						}
						if(checkedItems.length > 0) {
							$dropdownlist.jqxDropDownList('indeterminateIndex', 0);
						}
					}
					handleCheckChange = true;
				}
			}

			// Add class to drop down when default option is selected
			updateDefaultOptionClass();
			if(!isCheckboxes) {
				// Wrap default option to add default-option class
				var firstItem = $dropdownlist.jqxDropDownList('getItem', 0);
				if (firstItem && firstItem.value == '') {
					firstItem.html = '<span class="default-option">' + firstItem.html + '</span>';
				}
			}
			$dropdownlist.on('checkChange', function (event)
			{
				if (event.args) {
					updateDefaultOptionClass();
				}
			});
			$dropdownlist.on('select', function (event)
			{
				if (event.args) {
					updateDefaultOptionClass();
				}
			});

			function updateDefaultOptionClass() {
				var isDefault = false;
				if(isCheckboxes) {
					isDefault = $dropdownlist.jqxDropDownList('getCheckedItems').length == 0;
				}
				else {
					var selectedItem = $dropdownlist.jqxDropDownList('getSelectedItem');
					isDefault = selectedItem && selectedItem.value === '';
				}
				if(isDefault) {
					$dropdownlist.addClass('default-option');
				}
				else {
					$dropdownlist.removeClass('default-option');
				}
			}

			// Increase drop down width to be wider than button if data is very wide
			var checkboxWidth = isCheckboxes ? 16 : 0;
			var scrollbarWidth = !$dropdownlist.jqxDropDownList('autoDropDownHeight') ? 10 : 0;
			var maxWidth = 0;
			for (i = 0; i < items.length; i++) {
				if ($(items[i].element).outerWidth(true) > maxWidth) {
					maxWidth = $(items[i].element).outerWidth(true);
				}
			}

			$dropdownlist.jqxDropDownList({dropDownWidth: Math.max(maxWidth + checkboxWidth + scrollbarWidth + 24, $dropdownlist.width())});
		}

		// init async to avoid unresponsive script (when there are lots on the page)
		var all = this;

		// Use defaults for eachAsync unless page contains 10 or more dropdownlists
		var asyncDelay = 10;
		var asyncBulk = 500;
		if (this.length >= 10)
		{
		 // experimented with different delay and bulk values and found that 1 and 10 gave the fastest performance whilst keeping the UI responsive
			asyncDelay = 1;
			asyncBulk = 10;
		}

		return this.eachAsync({
			loop: function(){
				init($(this));
			},
			end: function()
			{
				// execute init of dropdown related plugins only after dropdownlist has finished init
				    $(document).trigger('afterAsyncDropdownList');
			},
			delay: asyncDelay,
			bulk: asyncBulk
		});
	};
	//
	// plugin defaults
	//
	$.fn.dropdownlist.defaults = {
		'show-checked-count': false
	};

})(jQuery);